import Vue from 'vue';
import Vuex from 'vuex';
import hotels from './modules/hotels';
import hotel from './modules/hotel';
import hero from './modules/hero';
import {
  GATEWAY,
  buidlURL,
  fetchRequest,
} from '@/api';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    hero,
    hotels,
    hotel
  },
  state: {
    errors: [],
    loading: [],
    modal: false,
    location: null,
    route: '',
    context: null,
  },
  getters: {
    isError: state => code =>
      !code ? state.errors.length > 0 : state.errors.includes(code),
    isLoading: state => name => {
      return !name ? state.loading.length > 0 : state.loading.includes(name);
    },
    context: state => {
      if (state.context) { return state.context; }
      // return 'pm';
      const origin =
        process.env.NODE_ENV !== 'production'
          ? 'https://well.ru'
          : window.location.origin;
      let result;
      switch (true) {
        case origin === 'https://well.ru':
          result = 'main';
          break;
        case origin === 'https://putevkamarket.ru':
          result = 'main-pm';
          break;
        case origin === 'https://au.well.ru':
        case origin === 'https://office.well.ru':
        case origin === 'https://test.well.ru':
        case origin === 'https://agent.putevkamarket.ru':
        case origin === 'https://turdoka.ru':
          result = 'office';
          break;
        case origin.search('.well.ru') !== -1:
          result = 'well';
          break;
        case origin.search('.putevkamarket.ru') !== -1:
          result = 'pm';
          break;
        case origin.search('.turdoka.ru') !== -1:
          result = 'td';
          break;
        default:
          result = 'main';
          break;
      }
      return result;
    },
    policyPageLink: (getters) => {
      switch (getters.context) {
        case 'main':
          return 'https://well.ru/about/acceptance_personal_data.php';
        case 'main-pm':
          return 'https://putevkamarket.ru/politiki-konfidencialnosti/';
        default:
          return '/kontakty/personal_data_acceptance/';
      }
    },
  },
  actions: {
    async authorize({ commit }) {
      const url = buidlURL(GATEWAY, { type: 'authorize', });
      return fetchRequest(url, response => {
        if (!response || response.error) {
          commit('setError', 'Access denied');
        }

        if (response.auth && response.auth.context) {
          commit('setContext', response.auth.context);
        }
      });
    },
    getLocation({ state, commit }) {
      if (state.route === '/') return;

      let hotel = null,
        country = null,
        region = null;
      if (state.route === '/hotels') {
        if (
          state.hero.direction.type &&
          state.hero.direction.type === 'Country'
        ) {
          country = {
            name: state.hero.direction.country,
            country_code: state.hero.direction.country_code
          };
        } else {
          if (state.hotels.hotels.length > 0) {
            country = {
              name: state.hotels.hotels.find(h => h.info).info.country,
              country_code: state.hotels.hotels.find(h => h.info).info
                .country_code
            };
            region = {
              name: state.hotels.hotels.find(h => h.info).info.city,
              id: state.hotels.hotels.find(h => h.info).info.region_id
            };
          }
        }
      } else if (state.hotel.hotel && state.hotel.hotel.info) {
        country = {
          name: state.hotel.hotel.info.country,
          country_code: state.hotel.hotel.info.country_code
        };
        region = {
          name: state.hotel.hotel.info.city,
          id: state.hotel.hotel.info.region_id
        };
        hotel = {
          name: state.hotel.hotel.info.name,
          id: state.hotel.hotel.info.id
        };
      }
      commit('setLocation', { region, country, hotel });
    }
  },
  mutations: {
    setError(state, error) {
      state.errors.push(error);
    },
    setLoading(state, name) {
      state.loading = state.loading.includes(name)
        ? state.loading.filter(el => el !== name)
        : [...state.loading, name];
    },
    setModal(state, value) {
      state.modal = value;
    },
    setLocation(state, location) {
      state.location = location;
    },
    setRoute(state, route) {
      state.route = route;
    },
    setContext(state, context) {
      state.context = context;
    }
  },
  strict: process.env.NODE_ENV !== 'production'
});
